const values = [
  {
    icon: 'ri-palette-line',
    title: '品质甄选',
    desc: '每一幅作品都经过人工审校，只收录高清、精美、值得收藏的同人插画。',
  },
  {
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    desc: '坚持每日持续收录新的画师作品，让图库始终保持新鲜与活力。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '尊重版权',
    desc: '全部作品署名收录、版权归原作者所有，支持投稿并保护画师权益。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端适配',
    desc: '支持电脑、平板与手机浏览，随时随地打开页面欣赏与下载美图。',
  },
];

export default function About() {
  return (
    <section id="about" className="relative w-full scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="text-sm font-medium uppercase tracking-widest text-primary-400">About Us</span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
              关于娜美同人图鉴
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-300 md:text-base">
              娜美同人图鉴是一个专注整理娜美同人插画、壁纸与画集资源的收藏平台。我们相信每一幅画作都承载着创作者对角色与世界的热爱，也值得被更多喜欢她的人看见。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-300 md:text-base">
              我们从众多画师的作品中精选高清图集，按清新水彩、明亮插画、厚涂写实、赛博霓虹、水墨意境、星夜幻想等风格分门别类，也支持按角色与标签定位，让收藏和下载都更简单顺手。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#latest"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                开始浏览
              </a>
              <a
                href="#faq"
                className="whitespace-nowrap rounded-md border border-background-300/60 px-5 py-2.5 text-sm font-medium text-foreground-200 transition-colors hover:border-primary-500 hover:text-primary-300"
              >
                了解规则
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {values.map((value) => (
              <div
                key={value.title}
                className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200/60"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/10 text-primary-400">
                  <i className={`${value.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-50">{value.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-300">{value.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}